// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"0115e6ed","769":"d39d2feb"}[chunkId] + ".chunk.js";
};